import type { HgChangeClubOptions } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { PKR_LOADERS } from '../../../../constants';
import { useHomeGamesWidget } from '../../../../model';

const usePutClubOptions = () => {
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const loadingState = useSelector(widgetSelect.loading);
  const { clubId } = useParams<{ clubId: string }>();
  const loading = loadingState[PKR_LOADERS.clubOptionsById(clubId)] ?? true;

  const onClubOptionsChange = useCallback(
    (payload: HgChangeClubOptions) => {
      widgetDispatch.clubOptions({ clubId: Number(clubId), method: 'PUT', ...payload });
    },
    [clubId, widgetDispatch]
  );

  return { onClubOptionsChange, loading };
};

export default usePutClubOptions;
